

























import { Component, Mixins, Watch, Vue } from 'vue-property-decorator'
import CustomForm from '@/components/custom-form/index.vue'
import ViewUI from 'view-design';
import Ajax from '@/lib/ajax'
import axios from 'axios'
import appconst from '@/lib/appconst'

@Component({
  components: {
    CustomForm
  }
})
export default class DefaultForm extends Vue {
  config: any = {}
  routeParams = {}
  get title() {
    return this.config.title
  }
  get hasSubmitBtn() {
    return this.config.hasSubmitBtn != null ? this.config.hasSubmitBtn : true
  }
  get hasResetBtn() {
    return this.config.hasResetBtn != null ? this.config.hasResetBtn : false
  }
  /**
   * 是否行内布局
   */
  get isinline() {
    return this.config.isinline != null ? this.config.isinline : false
  }
  get submitText() {
    return this.config.submitText != null ? this.config.submitText : '提交'
  }

  get filters() {
    return this.config.filters || []
  }

  created() {}

  @Watch('$route', {
    immediate: true
  })
  routeWatch() {
    let query: any = this.$route.query
    for (let key in this.$route.query) {
      this.routeParams[key] = JSON.parse(query[key])
    }
    ViewUI['LoadingBar'].finish();
    this.init()
  }

  /**
   * 获取表单配置信息
   */
  init() {
    axios
      .get(`${appconst.appBaseUrl}/${this.$route.meta.jsonUrl}.json`)
      .then(res => {
        if (res.data) {
          this.config = res.data
          this.getData()

          if (this.config.filterData) {
            this.config.filterData.forEach(item => {
              if (item.filed) {
                this.getFilterData(item)
              }
            })
          }
        }
      })
  }

  /**
   * 获取表单下拉数据
   */
  getFilterData(params) {
    let obj = {}

    for (let key in params.params) {
      obj[key] = this.routeParams[key]
    }

    Ajax[params.axiosType](params.url, { params: obj })
      .then(res => {
        if (res.data) {
          this.config.filters.forEach(item => {
            if (item.key == params.filed) {
              switch (item.type) {
                case 'select':
                  item.options = [
                    {
                      value: 0,
                      text: '标卡1'
                    },
                    {
                      value: 1,
                      text: '银卡2'
                    },
                    {
                      value: 2,
                      text: '金卡3'
                    },
                    {
                      value: 3,
                      text: '白金卡4'
                    }
                  ]
                  break
              }
            }
          })
        }
      })
      .catch(err => {})
  }

  /**
   * 获取表单数据
   */
  getData() {
    let { getData } = this.config
    if (!this.routeParams[getData.params]) {
      return
    }
    Ajax[getData.axiosType](
      getData.url + `/${this.routeParams[getData.params]}`
    )
      .then(res => {
        if (res.data) {
          let params = {}
          getData.fileds.forEach(item => {
            params[item] = res.data[item]
          })
          ;(this.$refs.formEdit as any).setForm(params)
        }
      })
      .catch(err => {})
  }

  onSubmit(form, valid) {
    if (valid) {
      let { postData } = this.config
      let obj = {}
      let params = {}
      postData.fileds.forEach(item => {
        if (this.routeParams[item]) {
          params[item] = this.routeParams[item]
        }
        obj[item] = form[item]
      })

      Object.assign(params, obj)
      if (this.routeParams[postData.editId]) {
      }
      let axiosType = this.routeParams[postData.editId]
        ? postData.editAxiosType
        : postData.axiosType
      let postUrl = postData.editUrl
        ? postData.editUrl
        : postData.url
      let url = this.routeParams[postData.editId]
        ? (postUrl + '/' + this.routeParams[postData.editId])
        : postUrl
      Ajax[axiosType](url, params)
        .then(res => {
          this.$Message.success(
            this.routeParams[postData.editId] ? '修改成功' : '添加成功'
          )
          if (postData.redirectName) {
            this.$router.push({ name: postData.redirectName, replace: true })
          }
        })
        .catch(err => {})
    }
  }
}
